import React, { useCallback } from "react";
import Products from "../Pages/Products/Products";
import { Route } from "react-router-dom";
import { ROUTE_LINKS } from "../utilities/constants";
import Categories from "../Pages/Categories/Categories";
import Brands from "../Pages/Brands/Brands";
import Users from "../Pages/Users/Users";
import Company from "../Pages/Company/Company";
import Dashboard from "../Pages/Dashboard/Dashboard";
import CRM from "../Pages/CRM/CRM";
import Orders from "../Pages/Orders/Orders";
import Contacts from "../Pages/Contacts/Contacts";
import Accounting from "../Pages/Accounting/Accounting";
import Warehouse from "../Pages/Warehouse/Warehouse";
import ContactCenter from "../Pages/ContactCenter/ContactCenter";
import Subscription from "../Pages/IonSubscription/Subscription";
import Setting from "../Pages/Setting/Setting";
import Attributes from "../Pages/Attributes/Attributes";
import GoogleAnalytics from "../Pages/GoggleAnalytics/GoogleAnalytics";

function useRoutes() {
  const components = {
    [ROUTE_LINKS.productsRoute]: <Products />,
    [ROUTE_LINKS.categoryRoute]: <Categories />,
    [ROUTE_LINKS.brandsRoute]: <Brands />,
    [ROUTE_LINKS.brandsRoute]: <Brands />,
    [ROUTE_LINKS.attributesRoute]: <Attributes />,
    [ROUTE_LINKS.userRoute]: <Users />,
    [ROUTE_LINKS.companyRoute]: <Company />,

    //
    [ROUTE_LINKS.dashboardRoute]: <Dashboard />,
    [ROUTE_LINKS.googleAnalyticsRoute]: <GoogleAnalytics />,
    [ROUTE_LINKS.crmRoute]: <CRM />,
    [ROUTE_LINKS.ordersRoute]: <Orders />,
    [ROUTE_LINKS.contactsRoute]: <Contacts />,
    [ROUTE_LINKS.accountingRoute]: <Accounting />,
    [ROUTE_LINKS.warehouseRoute]: <Warehouse />,
    [ROUTE_LINKS.contactCenterRoute]: <ContactCenter />,
    [ROUTE_LINKS.subscriptionRoute]: <Subscription />,
    [ROUTE_LINKS.settingRoute]: <Setting />,
  };
  const renderRoute = (list = []) => {
    const routesList = [];
    list.map((route, index) => {
      routesList.push(
        <Route
          key={index}
          path={route.link}
          element={components?.[route.link] || <>Page not Found</>}
        />
      );
      if (route.children) {
        routesList.push(...renderRoute(route.children));
      }
    });
    return routesList;
  };

  return {
    renderRoute,
  };
}

export default useRoutes;
